const POLL_INTERVAL_MS = 60000;
const HIDDEN_GRACE_MS = 20000;

const stopPolling = pollTimerIdRef => {
  if (pollTimerIdRef.value) {
    clearInterval(pollTimerIdRef.value);
    pollTimerIdRef.value = null;
  }
};

const startPolling = ({ pollTimerIdRef, fetchQueueFn, immediate = false }) => {
  stopPolling(pollTimerIdRef);
  if (immediate) {
    fetchQueueFn();
  }
  pollTimerIdRef.value = setInterval(fetchQueueFn, POLL_INTERVAL_MS);
};

const pausePollingForInFlight = ({ inFlightActionsRef, pollTimerIdRef }) => {
  if (!inFlightActionsRef) return;
  inFlightActionsRef.value += 1;
  if (inFlightActionsRef.value === 1 && pollTimerIdRef) {
    stopPolling(pollTimerIdRef);
  }
};

const resumePollingForInFlight = ({ inFlightActionsRef, pollTimerIdRef, fetchQueueFn }) => {
  if (!inFlightActionsRef) return;
  inFlightActionsRef.value = Math.max(0, inFlightActionsRef.value - 1);
  if (inFlightActionsRef.value === 0 && pollTimerIdRef && !document.hidden) {
    startPolling({ pollTimerIdRef, fetchQueueFn, immediate: false });
  }
};

const handleVisibilityChange = ({
  pauseTimerIdRef,
  pollTimerIdRef,
  fetchQueueFn,
  inFlightActionsRef
}) => {
  if (document.hidden) {
    if (pauseTimerIdRef.value) {
      clearTimeout(pauseTimerIdRef.value);
      pauseTimerIdRef.value = null;
    }
    pauseTimerIdRef.value = setTimeout(() => stopPolling(pollTimerIdRef), HIDDEN_GRACE_MS);
    return;
  }

  if (pauseTimerIdRef.value) {
    clearTimeout(pauseTimerIdRef.value);
    pauseTimerIdRef.value = null;
  }

  if (inFlightActionsRef.value > 0) return;
  startPolling({ pollTimerIdRef, fetchQueueFn, immediate: true });
};

export {
  POLL_INTERVAL_MS,
  HIDDEN_GRACE_MS,
  stopPolling,
  startPolling,
  pausePollingForInFlight,
  resumePollingForInFlight,
  handleVisibilityChange
};
